module.exports = __webpack_public_path__ + "static/media/Emine Tarın - header.17da0bd9.png";